import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchFeatures() {
  const { data } = await axios.get(`${API}/features`);
  return data;
}

export async function recommend(answers) {
  const { data } = await axios.post(`${API}/recommend`, { answers });
  return data;
}

export async function expertEvaluate(features) {
  const { data } = await axios.post(`${API}/expert`, { features });
  return data;
}

export async function shareProject(payload) {
  const { data } = await axios.post(`${API}/projects/share`, payload);
  return data; // { code }
}

export async function loadSharedProject(code) {
  const { data } = await axios.get(`${API}/projects/share/${code}`);
  return data;
}
